/* eslint-disable eqeqeq */
import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import style from './style/zaptic-multi-select-style'

export enum Events {
    onOptionsUpdated = 'onOptionsUpdated',
}

export interface CustomEventPayload {
    [Events.onOptionsUpdated]: Array<string | number>
}

export interface Option {
    title?: string
    titleTranslationKey?: string
    details?: string
    detailsTranslationKey?: string
    value: string | number
}

@customElement('zaptic-multi-select')
export class MultiSelect extends LitElement {
    static styles = style

    @property({ type: Array })
    selectedValues: Array<Option['value']> = []

    @property({ type: Array })
    options: Option[] = []

    render() {
        return html`<div class="container">${this.options.map((option) => this.OptionElement(option))}</div>`
    }

    OptionElement(option: Option) {
        const isSelected = this.isOptionSelected(option)
        const title = option.titleTranslationKey ? window.i18n(option.titleTranslationKey) : option.title
        const details = option.detailsTranslationKey ? window.i18n(option.detailsTranslationKey) : option.details

        return html`<div class="option" @click=${() => this.onToggle(option.value, !isSelected)}>
                <zaptic-checkbox class="checkbox" .selected=${isSelected}></zaptic-checkbox>
                <span class="title">${title}</span>
                ${details && `<span class="details">${details}</span>`}
            </div>
        </div>`
    }

    isOptionSelected(option: Option) {
        return this.selectedValues.some((value) => value == option.value)
    }

    onToggle(value: string | number, toBeAdded: boolean) {
        const newValues = toBeAdded
            ? this.selectedValues.concat(value)
            : this.selectedValues.filter((selectedValue) => selectedValue != value)
        this.dispatchEvent(
            new CustomEvent<CustomEventPayload[Events.onOptionsUpdated]>(Events.onOptionsUpdated, {
                detail: newValues,
            })
        )
    }
}
